import React, {
    useRef,
    memo,
    HTMLProps,
    useEffect,
    MutableRefObject,
} from 'react';
import cn from 'classnames';
import { PLACE_HOLDER } from '@zmedia/bm-soccer-ui/constants';
import { useImage } from '@zmedia/bm-soccer-ui/hooks/useImage';
import { Image } from '../base';
import styles from './styles.module.scss';

interface IProps extends HTMLProps<HTMLImageElement> {
    className?: string;
    src: string;
    alt?: string;
    title?: string;
    size?: number;
    rounded?: boolean;
    domRef?: any;
}

export function LazyloadImage({
    src,
    size = 48,
    alt,
    className,
    domRef,
    ...rest
}: IProps) {
    const imgRef: MutableRefObject<HTMLImageElement | null> = useRef<HTMLImageElement>(
        null
    );
    const [imgSrc] = useImage({ src, imgRef, alt });

    const onLoad = (event: any) => {
        if (imgSrc !== PLACE_HOLDER.IMAGE) {
            event.target.classList.add(styles['loaded']);
        }
    };

    useEffect(() => {
        if (domRef) {
            domRef.current = imgRef.current;
        }
    }, []);

    return (
        <Image
            {...rest}
            ref={imgRef}
            src={imgSrc}
            size={size}
            alt={alt}
            onLoad={onLoad}
            className={cn(className, styles['lazy-image'])}
        />
    );
}

export default memo(LazyloadImage);
